"use strict";

exports.__esModule = true;
var _DeviceDataItemSubscription = require("./DeviceDataItemSubscription");
Object.keys(_DeviceDataItemSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemSubscription[key]) return;
  exports[key] = _DeviceDataItemSubscription[key];
});